module.exports = __webpack_public_path__ + "static/media/HomeFastTransition.3f14ac07.svg";